import { Localized } from "@fluent/react";
import { LoadingButton } from "@mui/lab";
import { ReactNode } from "react";

interface CancelButtonProps {
    loading: boolean;
    onClick: () => void;
    disabled?: boolean;
    label?: ReactNode
}

export const CancelButton: React.FC<CancelButtonProps> = ({ loading, disabled = false, onClick, label }) => {
    return (
        <LoadingButton
            loading={loading}
            size="small"
            color="primary"
            variant="outlined"
            disabled={disabled}
            onClick={onClick}
        >
            {label ? label : <Localized id="cancel">_cancel</Localized>}
        </LoadingButton>
    );
};
